module.exports = __webpack_public_path__ + "eye.cdjyHwZj.svg";